module.exports = __webpack_public_path__ + "icons/infoExclamationRed.3946d6832b3d94658dace9c2d887c6ce.svg";